'use client'

import { cn } from '../../lib/cn'
import { CodeWindowBase, type CodeWindowBaseProps } from './code-window-base'

export interface CodeWindowHeroProps extends Omit<CodeWindowBaseProps, 'contentClassName'> {
  /** Size variant for the code window */
  size?: 'fit' | 'sm' | 'md' | 'lg' | 'full'
}

const sizeClasses: Record<NonNullable<CodeWindowHeroProps['size']>, { container: string; content: string }> = {
  fit: { container: '', content: '' }, // No constraints, adapts to content
  sm: { container: '', content: 'min-h-[280px] max-h-[280px]' },
  md: { container: '', content: 'min-h-[400px] max-h-[400px]' },
  lg: { container: '', content: 'min-h-[500px] max-h-[500px]' },
  full: { container: 'h-full w-full', content: 'h-full' },
}

/**
 * CodeWindowHero - Code window with size variants
 *
 * Size options:
 * - fit (default): Adapts to code content height
 * - sm/md/lg: Fixed heights (280/400/500px) for layout consistency
 * - full: Fills parent container
 */
export function CodeWindowHero({
  size = 'fit',
  className,
  ...props
}: CodeWindowHeroProps) {
  return (
    <CodeWindowBase
      {...props}
      className={cn('flex flex-col', sizeClasses[size].container, className)}
      contentClassName={cn('flex-1', sizeClasses[size].content)}
    />
  )
}
